import { useMemo } from 'react';
import { useFliptBoolean } from 'lib/flipt/hooks';
import { FeatureFlagKeys } from 'lib/flipt/constants/flagKeys';
import {
  BuyOrderType,
  Expiry,
  SellOrderType,
} from 'global/Securities/types/transaction';
import { ORDER_TYPE } from 'constants/trading';
import { useTradingInfoStore } from 'global/Securities/stores/useTradingInfoStore';
import realTradingStore from '../RealTradingModal/store';
import tradingModalStore from '../store';

export default function useEnableSplitOrder(formType: 'buy' | 'sell') {
  const { expiry, type: orderType } = realTradingStore();
  const { orderType: modalOrderType } = tradingModalStore();
  const splitOrderInfo = useTradingInfoStore((s) => s.splitOrder);
  const isSplitOrderFeatureEnabled = useFliptBoolean(
    FeatureFlagKeys.SPLIT_ORDER,
  );

  const isShowSplitOrder = useMemo(() => {
    // set to true in case we have failed to get splitorder info
    let isMarketOpen = true;

    if (
      splitOrderInfo &&
      typeof splitOrderInfo.remaining_trading_close === 'number'
    ) {
      isMarketOpen = splitOrderInfo.remaining_trading_close !== 0;
    }

    if (formType === 'buy') {
      return (
        orderType === BuyOrderType.LimitOrder &&
        // Order type is not amend BUY
        modalOrderType !== ORDER_TYPE.AMEND_BUY &&
        // feature flag enabled
        isSplitOrderFeatureEnabled &&
        // disable split order on GTC
        expiry !== Expiry.GoodTillCancelled &&
        // only show when market opens
        isMarketOpen
      );
    }

    // order is limit order BUY / SELL
    return (
      orderType === SellOrderType.LimitOrder &&
      // Order type is not amend SELL
      modalOrderType !== ORDER_TYPE.AMEND_SELL &&
      // feature flag enabled
      isSplitOrderFeatureEnabled &&
      // disable split order on GTC
      expiry !== Expiry.GoodTillCancelled &&
      // only show when market opens
      isMarketOpen
    );
  }, [orderType, isSplitOrderFeatureEnabled, expiry, splitOrderInfo]);

  return isShowSplitOrder;
}
